import { useCallback, useEffect, useState } from "react";
import { api } from "./api";

export function useApiData<T>(path: string, initial: T) {
  const [data, setData] = useState<T>(initial);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const refresh = useCallback(async () => {
    setLoading(true); setError("");
    try { setData(await api<T>(path)); }
    catch (requestError) { setError((requestError as Error).message); }
    finally { setLoading(false); }
  }, [path]);
  useEffect(() => { void refresh(); }, [refresh]);
  return { data, setData, loading, error, refresh };
}
